import { BubbleMenu } from "@tiptap/react/menus";

import { useEditorContext } from "../../editor/EditorContext";
import { FileSection } from "./FileSection";
import { LinkSection } from "./LinkSection";
import { TableSection } from "./TableSection";
import {
  FloatingToolbarProvider,
  type FloatingToolbarFeatures,
  useFloatingToolbar,
} from "./context";
import {
  shouldShowFileSection,
  shouldShowLinkSection,
  shouldShowTableSection,
} from "./predicates";

const FloatingToolbarMenu = () => {
  const { editor } = useEditorContext();
  const { features, mode } = useFloatingToolbar();

  if (!editor) {
    return null;
  }

  return (
    <BubbleMenu
      key="floating-toolbar"
      editor={editor}
      updateDelay={0}
      style={{ zIndex: 11, background: "#fff" }}
      options={{ placement: "top-start", offset: 4 }}
      shouldShow={({ editor: instance, state }) => {
        if (mode.type !== "idle") {
          return true;
        }
        if (features.link && shouldShowLinkSection(instance, state)) {
          return true;
        }
        if (features.file && shouldShowFileSection(instance, state)) {
          return true;
        }
        if (features.table && shouldShowTableSection(instance)) {
          return true;
        }
        return false;
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <LinkSection />
        <FileSection />
        <TableSection />
      </div>
    </BubbleMenu>
  );
};

export type FloatingToolbarProps = FloatingToolbarFeatures;

export const FloatingToolbar = ({
  link,
  file,
  table,
}: FloatingToolbarProps) => (
  <FloatingToolbarProvider features={{ link, file, table }}>
    <FloatingToolbarMenu />
  </FloatingToolbarProvider>
);
